import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import i18n from '../../i18n/i18n';

interface LoadingOverlayProps {
  open: boolean;
  color?: string;
  messageId?: string;
  backgroundColor?: string;
  zIndex?: number;
}

const Overlay = styled.div<{ backgroundColor: string; zIndex: number }>`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: ${({ backgroundColor }) => backgroundColor};
  z-index: ${({ zIndex }) => zIndex};
`;

const Message = styled.div`
  color: black;
  font-size: 16px;
  text-align: center;
`;

function LoadingOverlay({
  open,
  color = '#fff',
  messageId = 'loading',
  backgroundColor = 'rgba(255, 255, 255, 0.7)',
  zIndex = 20,
}: LoadingOverlayProps) {
  if (!open) return null;

  return (
    <Overlay backgroundColor={backgroundColor} zIndex={zIndex}>
      <CircularProgress style={{ color }} />
      <Message /*style={{ color }}*/>{i18n.t(messageId)}</Message>
    </Overlay>
  );
}

export default LoadingOverlay;
